import React, { useContext, useEffect }from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import Page404 from './pages/404'
import SelfTroubleShooting from './pages/self-trouble-shooting'
import EnergyReport from './pages/energy-report'
import TripsReport from './pages/trips-report'
import ChargingRealTimeCurve from './pages/charging-real-time-curve'
import AiDriving from './pages/ai-driving'
import MediaVip from './pages/media-vip'
import MediaVipV2 from './pages/media-vip-v2'
import MediaVipV3 from './pages/media-vip-v3'
import MonaOta from './pages/mona-ota'
import { ThemeModeContext } from './ThemeModeContext'
import JSBridge from '@xpeng/js-bridge'
import { themeArray } from './config'
import ChargingRealTimeCurveV2 from './pages/charging-real-time-curve_v2'

function App() {
  // 颜色主题
  const themeModeContext = useContext(ThemeModeContext)
  // 监听主题切换
  const listenThemeChange = () => {
    JSBridge.registerHandler('onThemeModeChange', (data, callback) => {
      console.log(data, 'onThemeModeChange');
      if (themeArray.includes(data.mode)) {
        if (window.location.href.includes('mona_ota')) {
          document.documentElement.setAttribute('data-theme', 'light')
        } else {
          themeModeContext?.toggleMode(data.mode)
          document.documentElement.setAttribute('data-theme', data.mode)
        }
      }
    })
  }
  useEffect(() => {
    listenThemeChange()
  }, [])
  return (
    <Switch>
      <Route path="/car-service/" exact render={() => <Redirect to='/car-service/self_trouble_shooting'></Redirect>}>
      </Route>
      <Route path="/car-service/self_trouble_shooting">
        <SelfTroubleShooting></SelfTroubleShooting>
      </Route>
      <Route path="/car-service/energy_report">
        <EnergyReport></EnergyReport>
      </Route>
      <Route path="/car-service/trips_report">
        <TripsReport></TripsReport>
      </Route>
      <Route path="/car-service/charging_real_time_curve">
        <ChargingRealTimeCurve></ChargingRealTimeCurve>
      </Route>
      <Route path="/car-service/charging_real_time_curve_v2">
        <ChargingRealTimeCurveV2></ChargingRealTimeCurveV2>
      </Route>
      <Route path="/car-service/ai_driving">
        <AiDriving></AiDriving>
      </Route>
      <Route path="/car-service/media_vip">
        <MediaVip></MediaVip>
      </Route>
      <Route path="/car-service/media_vip_v2">
        <MediaVipV2></MediaVipV2>
      </Route>
      <Route path="/car-service/media_vip_v3">
        <MediaVipV3></MediaVipV3>
      </Route>
      <Route path="/car-service/mona_ota">
        <MonaOta></MonaOta>
      </Route>
      <Route>
        <Page404 />
      </Route>
    </Switch>
  )
}

export default App
